import dayjs from 'dayjs';
// Types
import { MemorabiliaStatus } from 'api/graphql-global-types';

type MemorabiliaWithImages = {
  images: { isMainImage: boolean | null; url: string }[] | null;
};

export const getMemorabiliaHoverImage = (
  memorabilia: MemorabiliaWithImages | null | undefined
): string | undefined => {
  if (!memorabilia?.images || memorabilia.images.length < 2) return undefined;

  const mainImageUrl = memorabilia.images.find((img) => img.isMainImage)?.url;

  const otherImage = memorabilia.images.find(
    (img) => img.url && img.url !== mainImageUrl
  );

  return otherImage?.url ?? undefined;
};
import { GetAnyProductSales_getAnyProductSales_entities_order_subOrders } from 'api/merch/types/GetAnyProductSales';
import { GetOrders_getOrders_entities_subOrders } from 'api/merch/types/GetOrders';

export const renderAccountProductComment = (
  status: MemorabiliaStatus,
  isForAuction?: boolean | null
): string => {
  switch (status) {
    case MemorabiliaStatus.Active:
      return 'Item has been listed';
    case MemorabiliaStatus.Removed:
      if (!isForAuction) {
        return 'Item was removed. You may re-list it from the action column to the right.';
      } else {
        return 'Item was removed.';
      }
    case MemorabiliaStatus.Sold:
      return 'All items have been sold';
    case MemorabiliaStatus.Expired:
      return 'This item is expired. You can list it again from action tab on the right.';
    default:
      return '';
  }
};

export const getNumberOfSuborderItems = (
  subOrders: GetOrders_getOrders_entities_subOrders[]
): number => {
  const numberOfItems = subOrders.reduce((prev: number, acc) => {
    return prev + acc.merchOrderItems.length;
  }, 0);

  return numberOfItems;
};

export const getDisplayDate = (date: string | null): string => {
  if (date && dayjs(date).isValid()) {
    return dayjs(date).format('MM/DD/YYYY');
  }

  return '\u2014';
};

export const getMerchType = (
  suborders: GetAnyProductSales_getAnyProductSales_entities_order_subOrders[]
): string => {
  const hasMerch = suborders.some(({ merchOrderItems }) =>
    merchOrderItems.some((item) => item.memorabilia === null)
  );
  const hasMemorabilia = suborders.some(({ merchOrderItems }) =>
    merchOrderItems.some((item) => item.memorabilia)
  );

  const types: string[] = [];

  if (hasMerch) {
    types.push('Merch');
  }

  if (hasMemorabilia) {
    types.push('Memorabilia');
  }

  if (types.length === 0) {
    return 'Memorabilia';
  }

  // if there are multiple types, join them with a slash-if there is only one type, return the type
  return types.join('/');
};
